import type { UseProctoringReturn } from 'proctoring-sdk/index'

export enum PermissionKind {
    Webcam = 'webcam',
    Microphone = 'microphone',
    Screen = 'screen',
}

export enum PermissionStatus {
    Prompt = 'prompt',
    Granted = 'granted',
    Denied = 'denied',
}

export enum NetworkStrength {
    Poor = 'poor',
    Fair = 'fair',
    Good = 'good',
}

export enum MediaTrackKind {
    Video = 'video',
    Audio = 'audio',
}

export enum ProctoringDisconnectReason {
    WebcamDisconnected = 'WEBCAM_DISCONNECTED',
    ScreenShareStopped = 'SCREEN_SHARE_STOPPED',
}

export enum ProctoringSessionStatus {
    Completed = 'completed',
    Closed = 'closed',
    Failed = 'failed',
}

export type PermissionItemProps = {
    label: string
    kind: PermissionKind
    status?: PermissionStatus
    availableDevices?: MediaDeviceInfo[]
    hideAvailableDevices?: boolean
    selectedDeviceId?: string | null
    onDeviceChange?: (deviceId: string) => void
}

export type PermissionItemState = {
    kind: PermissionKind
    label: string
    hideAvailableDevices: boolean
    status: PermissionStatus
    availableDevices: MediaDeviceInfo[]
    selectedDeviceId: string | null
    onDeviceChange?: (deviceId: string) => void
}

export type PermissionDef = {
    kind: PermissionKind
    label: string
    hideAvailableDevices: boolean
}

export type ProctoredShellRenderProps = {
    proctoring: UseProctoringReturn
    permissionsGranted: boolean
    beginNextTaskCycle: () => Promise<void>
    endProctoringSession: () => Promise<void>
}

export type ProctoringPermissionsGateProps = {
    proctoring: UseProctoringReturn
    browserSupported: boolean
    onPermissionsGranted: () => void
    profile?: string
    disconnectReason?: string | null
}
